import { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import ShareView from "@/pages/ShareView";
import ViewSecret from "@/pages/ViewSecret";
import LegalPage from "@/pages/LegalPage";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { LangProvider } from "@/lib/i18n";
import { ThemeProvider, useTheme } from "@/lib/theme";
import "@/App.css";

const TOAST_STYLE_BASE = {
  borderRadius: 0,
  fontFamily: "JetBrains Mono, monospace",
  fontSize: 12,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
};

function BootFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] dark:bg-[#0A0A0A]">
      <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-widest text-neutral-500 animate-pulse">
        <span className="inline-block w-2 h-2 bg-[#00a844] dark:bg-[#00ff66] rounded-full" />
        loading
      </div>
    </div>
  );
}

function AppShell() {
  const { theme } = useTheme();
  const toastStyle =
    theme === "dark"
      ? { ...TOAST_STYLE_BASE, background: "#0a0a0a", border: "1px solid rgba(255,255,255,0.15)", color: "#f5f5f5" }
      : { ...TOAST_STYLE_BASE, background: "#ffffff", border: "1px solid rgba(0,0,0,0.15)", color: "#0a0a0a" };
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-[#FAFAFA] dark:bg-[#0A0A0A] text-neutral-900 dark:text-neutral-100 antialiased">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/created/:id" element={<ShareView />} />
            <Route path="/s/:id" element={<ViewSecret />} />
            <Route
              path="/impressum"
              element={<LegalPage pageKey="impressum" fileName="impressum" />}
            />
            <Route
              path="/datenschutz"
              element={<LegalPage pageKey="privacy" fileName="datenschutz" />}
            />
          </Routes>
        </main>
        <Footer />
        <Toaster theme={theme} position="bottom-right" toastOptions={{ style: toastStyle }} />
      </div>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <Suspense fallback={<BootFallback />}>
        <LangProvider>
          <AppShell />
        </LangProvider>
      </Suspense>
    </ThemeProvider>
  );
}
